/* eslint-disable no-unused-expressions */
/* eslint-disable react/prop-types */
/* eslint-disable max-len */
import React, { useState, useEffect } from 'react';
import {
  Form,
  Button,
  Row,
  Spin,
  Card,
  Tabs,
  Col,
  message,
} from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined, RedoOutlined } from '@ant-design/icons';
import { formatReceived } from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';
import Table from 'components/Table';
import { makeOnChangeTabKey } from 'utils/tabsManagement';
import makeMessager from 'utils/complexFormsMessages';
import FormSubmitControls from 'components/FormSubmitControls';
import ModalDelete from 'components/ModalDelete';
import ModalConfirmation from 'components/ModalConfirmation';
import { getModelPermission } from 'utils/permission';
import {
  getEstadosGlobales,
  getTipoDeduccionDeNomina,
  getCuentasContables,
  getAcreedores,
} from 'api/catalogos/index';
import { getTiposDescuentos } from 'api/nominas/descuentos/tiposDescuentos';
import {
  getConfiguracionDescuentos,
  postConfiguracionDescuento,
  deleteConfiguracionDescuento,
  patchConfiguracionDescuento,
  getConfiguracionDescuento,
} from 'api/nominas/descuentos/configuracionDescuentos';
import { checkToken } from 'api/utils';
import {
  SLUG_PATTERN,
  integerRegExp,
  FLOAT_NUMER_PATTERN,
} from 'utils/patterns';
import DescuentoGenerales from 'components/Nominas/Descuentos/Generales';
import DescuentoParametros from 'components/Nominas/Descuentos/Parametros';
import { deleteDescuentoPercepcion, getDescuentosPercepciones } from 'api/nominas/descuentos/descuentosPercepciones';
import { getFechasDevoulucionesEmpleados } from 'api/nominas/descuentos/fechasDevolucionesEmpleados';
import { getDestinosDelDescuento } from 'api/nominas/descuentos/destinosDelDescuento';
import makeTreeCuentasContable from 'utils/makeTreeFromCuentasContables';
import {
  DESTINO_DEL_DESCUENTO_PAGO_A_TERCEROS,
  DESTINO_DEL_DESCUENTO_PARA_DEVOLUCION_AL_EMPLEADO,

  ESTATUS_CANCELADO,
  ESTATUS_AUTORIZADO,
  ESTATUS_ACTIVO,
  ESTATUS_INACTIVO,
  DESCUENTO_RECURRENTE_Y_VARIABLE,
  DESCUENTO_TEMPORAL,
  DESCUENTO_UNICOS,
  DESCUENTO_RECURRENTE_Y_FIJO,
  DESCUENTO_DE_CALCULO_EXTERNO,
} from 'utils/constants';
import { getFormatosDeConsultas } from 'api/nominas/descuentos/formatosDeConsultas';
import { getAcreedoresCuentasContables } from 'api/configuraciones/acreedoresCuentasContables';
import DescuentoTipoDeNominaEmpleado, { descuentoTipoNominaEmpleadoPermission } from './DescuentosTiposNominasEmpleados';
import DescuentoTipoDeNomina, { descuentoTipoNominaPermission } from './DescuentosTiposDeNominas';

const { TabPane } = Tabs;

export const descuentosConfiguacionesPermission = {
  permissionModel: 'descuento',
  catalogsModels: [],
  tabsModels: [],
};

export const onErrorFields = (
  err,
  setLoading = null,
  formsInstances = [],
  setCurrentTabKey,
) => {
  if (typeof setLoading === 'function') {
    setLoading(false);
  }
  const errorKeys = err.errorFields.map((e) => e.name[0]);
  const formWithErrors = formsInstances.find(
    (obj) => obj.tabFields.some(
      (val) => errorKeys.includes(val),
    ),
  );
  if (formWithErrors) {
    setTimeout(() => {
      if (typeof setCurrentTabKey === 'function') {
        setCurrentTabKey(formWithErrors.tabKey);
      }
    });
  }
};

const DescuentosConfiguraciones = ({ permission }) => {
  const [form] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentTabKey, setCurrentTabKey] = useState('generales');
  const [mutable, setMutable] = useState(true);
  const [open, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [data, setData] = useState([]);
  const [estados, setEstados] = useState([]);
  const [tiposNominas, setTiposNominas] = useState([]);
  const [cuentas, setCuentas] = useState([]);
  const [acreedores, setAcreedores] = useState([]);
  const [tiposDescuentos, setTiposDescuentos] = useState([]);
  const [disableTabla, setDisableTabla] = useState(true);
  const [infoTooltipTipoDescuento, setInfoTooltipTipoDescuento] = useState();
  const [tipoDescuento, setTipoDescuento] = useState();
  const [destinosDelDescuento, setDestinosDelDescuento] = useState([]);
  const [fechasDevolucionesEmpleados, setFechasDevolucionesEmpleados] = useState([]);
  const [disabledCampoAcreedores, setDisabledCampoAcreedores] = useState(true);
  const [disabledCampoFechaDevolucion, setDisabledCampoFechaDevolucion] = useState([]);
  const [formatosDeConsultas, setFormatosDeConsultas] = useState([]);
  const [aplicaFormatoDeConsulta, setAplicaFormatoDeConsulta] = useState(false);
  const [confirmationVisible, setConfirmationVisible] = useState(false);
  const [confirmationCancelarVisible, setConfirmationCancelarVisible] = useState(false);
  const [confirmationReactivarVisible, setConfirmationReactivarVisible] = useState(false);
  const [estadosFiltered, setEstadosFiltered] = useState([]);
  const [confirmationVisibleEstatus, setConfirmationVisibleEstatus] = useState(false);
  const [estatusInactivo, setEstatusInactivo] = useState(false);
  const [estatusAutorizado, setEstatusAutorizado] = useState(false);
  const [aplicaPorcentaje, setAplicaPorcentaje] = useState(false);
  const [disableSave, setDisableSave] = useState(false);
  const [descuentoInfo, setDescuentoInfo] = useState();
  const [disaleAplicaPorcentaje, setDisableAplicaPorcentaje] = useState(false);
  const [disableAplicanRangosSalariales, setDisableAplicanRangoSalariales] = useState(false);
  const [disableRequiereDatosInformativos, setDisableRequiereDatosInformativos] = useState(false);

  const baseURI = 'nominas/descuentos';

  const getInfoTipoDescuento = () => {
    const value = form.getFieldValue('tipo_de_descuento');
    if (value) {
      const _descuento = tiposDescuentos.find((descuento) => descuento.agrupador === value);
      const _descuento_info = `${_descuento.nombre}: ${_descuento.descripcion}`;
      setInfoTooltipTipoDescuento(_descuento_info);
    } else {
      setInfoTooltipTipoDescuento('');
    }
  };

  const requiredFormStructure = [
    {
      parentTabKey: 'generales',
      tabKey: 'generales',
      tabFields: ['clave', 'concepto', 'tipo_de_descuento', 'destino_del_descuento', 'acreedor', 'cuenta_contable', 'tipo_deduccion_nomina',
        'prioridad_del_descuento', 'admite_mas_de_un_descuento_simultaneo'],
    },
    {
      parentTabKey: 'parametros',
      tabKey: 'parametros',
      tabFields: ['aplica_importe_fijo', 'aplica_importe_variable', 'aplica_porcentaje_para_importe_variable',
        'porcentaje_de_importe_variable', 'formula', 'aplica_importe_de_calculo_externo',
        'aplica_importe_base', 'aplica_periodo_unico_de_descuento', 'aplica_no_periodos_determinados',
        'aplica_determinacion_de_importe_fijo_de_descuento', 'aplica_no_de_descuento_con_que_inicia',
        'aplica_contador_de_descuentos', 'es_recurrente', 'aplica_cuenta_contable_del_empleado',
        'aplica_control_de_saldos', 'aparece_en_recibo_el_saldo', 'aplica_acumulado', 'aparece_en_recibo_el_acumulado',
        'requiere_datos_informativos', 'requiere_beneficiarios_externos', 'aplica_suspencion'],
    },
  ];

  const basicKeys = [
    'generales',
    'parametros',
  ];

  const complexForms = [];

  const formInstances = [
    form,
  ];

  const getPermissionEmpleados = getModelPermission(
    descuentoTipoNominaEmpleadoPermission.permissionModel,
    descuentoTipoNominaEmpleadoPermission.catalogsModels,
    descuentoTipoNominaEmpleadoPermission.tabsModels,
    false,
  );

  const getPermissionNominas = getModelPermission(
    descuentoTipoNominaPermission.permissionModel,
    descuentoTipoNominaPermission.catalogsModels,
    descuentoTipoNominaPermission.tabsModels,
    false,
  );

  // const calcularProfundidadMaxima = (arreglo) => {
  //   let maxProfundidad = 0;
  //   const calcularProfundidadRecursiva = (nodo, profundidad) => {
  //     maxProfundidad = Math.max(maxProfundidad, profundidad);
  //     if (!nodo.children || nodo.children.length === 0) {
  //       return;
  //     }
  //     nodo.children.forEach((hijo) => {
  //       calcularProfundidadRecursiva(hijo, profundidad + 1);
  //     });
  //   };
  //   arreglo.forEach((nodo) => {
  //     calcularProfundidadRecursiva(nodo, 1);
  //   });
  //   return maxProfundidad;
  // };

  // const agregarDisabledEnNivelMasProfundo = (arreglo) => {
  //   const profundidadMaxima = calcularProfundidadMaxima(arreglo);
  //   const agregarDisabledRecursivo = (nodo, profundidadActual) => {
  //     if (!nodo.children || nodo.children.length === 0) {
  //       if (profundidadActual === profundidadMaxima) {
  //         if (nodo?.tipo === 7) {
  //           // eslint-disable-next-line no-param-reassign
  //           nodo.disabled = false;
  //         } else {
  //           // eslint-disable-next-line no-param-reassign
  //           nodo.disabled = true;
  //         }
  //         return;
  //       }
  //       // eslint-disable-next-line no-param-reassign
  //       nodo.disabled = true;
  //       return;
  //     }
  //     if (profundidadActual === profundidadMaxima) {
  //       // eslint-disable-next-line no-param-reassign
  //       nodo.disabled = false;
  //     } else {
  //       // eslint-disable-next-line no-param-reassign
  //       nodo.disabled = true;
  //     }
  //     nodo.children.forEach((hijo) => {
  //       agregarDisabledRecursivo(hijo, profundidadActual + 1);
  //     });
  //   };
  //   arreglo.forEach((nodo) => {
  //     agregarDisabledRecursivo(nodo, 1);
  //   });
  // };

  const normalizeCuentasContables = (_data) => {
    if (_data) {
      const output = _data.map((item) => {
        const clone = { ...item };
        const children = normalizeCuentasContables(clone.children);
        const hasCuentasChildren = children.some((e) => e.conac);
        const selectable = clone.tipo !== 7 && !hasCuentasChildren;
        if (!children.length) {
          delete clone.children;
          return ({
            ...clone,
            title: `${clone.clave_visible || clone.clave} - ${clone.nombre}`,
            value: clone.id,
            key: clone.id,
            disabled: !selectable,
          });
        }
        return ({
          ...clone,
          title: `${clone.clave_visible || clone.clave} - ${clone.nombre}`,
          value: clone.id,
          key: clone.id,
          children,
          disabled: !selectable,
        });
      });
      return output;
    }
    return [];
  };

  // const flattenWithChildren = (arr) => {
  //   const flattened = [];
  //   const traverse = (items) => {
  //     items.forEach((item) => {
  //       const { children, ...itemWithoutChildren } = item;
  //       flattened.push(itemWithoutChildren);
  //       if (children && children.length > 0) {
  //         traverse(children);
  //       }
  //     });
  //   };
  //   traverse(arr);
  //   return flattened;
  // };

  const fetchData = async () => {
    setLoading(true);
    const _data = await getConfiguracionDescuentos();
    setData(formatReceived(_data));
    setLoading(false);
  };

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _destinosDelDescuento,
        _fechasDevolucionesEmpleados,
        _estados,
        _cuentas,
        _tiposNominas,
        _acreedores,
        _tiposDescuentos,
        _formatosDeConsultas,
        _data,
      ] = await Promise.all([
        getDestinosDelDescuento(),
        getFechasDevoulucionesEmpleados(),
        getEstadosGlobales(),
        getCuentasContables(),
        getTipoDeduccionDeNomina(),
        getAcreedores(),
        getTiposDescuentos({ estados_globales: ESTATUS_AUTORIZADO }),
        getFormatosDeConsultas(),
        getConfiguracionDescuentos(),
      ]);
      if (mounted) {
        setDestinosDelDescuento(_destinosDelDescuento);
        setFechasDevolucionesEmpleados(_fechasDevolucionesEmpleados);
        setEstados(_estados);
        const normalizedCuentas = normalizeCuentasContables(makeTreeCuentasContable(_cuentas));
        setCuentas(normalizedCuentas);
        setTiposNominas(_tiposNominas);
        setAcreedores(_acreedores);
        setTiposDescuentos(_tiposDescuentos);
        setFormatosDeConsultas(_formatosDeConsultas);
        setData(formatReceived(_data));
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
    // eslint-disable-next-line
  }, []);

  const onCancel = () => {
    setDescuentoInfo();
    setDisableAplicaPorcentaje(false);
    setEstatusInactivo(false);
    setDisableSave(false);
    setEstatusAutorizado(false);
    setDisableAplicanRangoSalariales(false);
    setDisableRequiereDatosInformativos(false);
    setConfirmationCancelarVisible(false);
    setConfirmationReactivarVisible(false);
    setSelectedRowKeys([]);
    setVisible(false);
    setMutable(true);
    setInfoTooltipTipoDescuento('');
    form.resetFields();
  };

  const isDisabled = (rowEstatus) => {
    if (rowEstatus !== ESTATUS_ACTIVO) {
      setDisableSave(true);
    }
  };

  const handleOnFinishConfirmationEstatus = async () => {
    setConfirmationVisibleEstatus(false);
  };
  const handleChangeAcreedor = async (acreedorId) => {
    // Si limpian el campo, no hacemos nada o limpiamos la cuenta
    if (!acreedorId) {
      form.setFieldsValue({ cuenta_contable: null });
      return;
    }

    setLoading(true);
    try {
      // Consultamos la relación Acreedor - Cuenta Contable
      const response = await getAcreedoresCuentasContables({ acreedor: acreedorId });

      // Manejo defensivo: la API podría devolver un arreglo o un objeto directo
      const relacion = Array.isArray(response) ? response[0] : response;

      if (relacion && relacion.cuenta_contable) {
        form.setFieldsValue({
          cuenta_contable: relacion.cuenta_contable,
        });
      } else {
        message.warning('Este acreedor no tiene una cuenta contable asociada.');
        form.setFieldsValue({ cuenta_contable: null });
      }
    } catch (error) {
      onError(error);
    } finally {
      setLoading(false);
    }
  };

  const onClickEdit = async (responseData = null) => {
    setLoading(true);
    const [key] = selectedRowKeys;
    const match = responseData || data.find((item) => item.id === key);
    const _descuento = await getConfiguracionDescuento(match.id);
    setDescuentoInfo(_descuento);
    if (_descuento?.estados_globales === ESTATUS_ACTIVO || _descuento?.estados_globales === ESTATUS_INACTIVO) {
      setEstadosFiltered(estados.filter((estado) => estado?.id === ESTATUS_INACTIVO || estado?.id === ESTATUS_ACTIVO));
    }
    if (_descuento?.estados_globales === ESTATUS_AUTORIZADO) {
      setEstadosFiltered(estados.filter((estado) => estado?.id === ESTATUS_AUTORIZADO));
    }
    if (_descuento?.estados_globales === ESTATUS_INACTIVO) {
      setEstatusInactivo(true);
    }
    if (_descuento?.estados_globales === ESTATUS_AUTORIZADO) {
      setEstatusAutorizado(true);
    }
    if (_descuento?.destino_del_descuento === DESTINO_DEL_DESCUENTO_PAGO_A_TERCEROS) {
      setDisabledCampoAcreedores(false);
      setDisabledCampoFechaDevolucion(true);
    } else if (_descuento?.destino_del_descuento === DESTINO_DEL_DESCUENTO_PARA_DEVOLUCION_AL_EMPLEADO) {
      setDisabledCampoFechaDevolucion(false);
      setDisabledCampoAcreedores(true);
    }
    if (_descuento?.tipo_de_descuento === DESCUENTO_RECURRENTE_Y_VARIABLE) {
      setDisableAplicanRangoSalariales(false);
    } else {
      setDisableAplicanRangoSalariales(true);
    }
    if (_descuento?.tipo_de_descuento === DESCUENTO_UNICOS) {
      setDisableRequiereDatosInformativos(true);
    } else {
      setDisableRequiereDatosInformativos(false);
    }
    getInfoTipoDescuento();
    setTimeout(() => {
      if (_descuento) {
        _descuento?.aplica_porcentaje_predeterminado_importe_variable ? setAplicaPorcentaje(true) : setAplicaPorcentaje(false);
        form.resetFields();
        setTimeout(() => {
          setTipoDescuento(_descuento?.tipo_de_descuento);
          form.setFieldsValue(formatReceived(_descuento));
          if (_descuento.acreedor) {
            // Opción A: Solo si la cuenta contable viene vacía en la BD, la buscamos
            if (!_descuento.cuenta_contable) {
              handleChangeAcreedor(_descuento.acreedor);
            }
          }
          setAplicaFormatoDeConsulta(formatReceived(_descuento)?.aplica_formato_de_consulta);
          isDisabled(_descuento?.estados_globales);
          setVisible(true);
        });
      }
    });
    setLoading(false);
  };

  const onFinish = async (_values, _continue = true) => {
    try {
      setLoading(true);
      await form.validateFields();
      const values = {
        ...form.getFieldsValue(),
      };
      const [key] = selectedRowKeys;
      const saved = await (key ? patchConfiguracionDescuento(key, values) : postConfiguracionDescuento(values));
      if (saved) {
        if (_continue) {
          await fetchData();
          setSelectedRowKeys([saved.id]);
          onClickEdit(saved);
        } else {
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      if (err.errorFields) {
        onErrorFields(
          err,
          setLoading,
          requiredFormStructure,
          setCurrentTabKey,
        );
        message.warn('Favor de corregir los errores señalados');
      } else {
        onError(
          err,
          setLoading,
          formInstances,
        );
      }
    }
  };

  const deleteItem = async () => {
    try {
      setLoading(true);
      if (selectedRowKeys.length) {
        const [key] = selectedRowKeys;
        const _descuentosPercepciones = await getDescuentosPercepciones();
        const _descuentoPercepcion = _descuentosPercepciones.filter((e) => e.descuento === key);
        _descuentoPercepcion.map(async (x) => {
          await deleteDescuentoPercepcion(x.id);
        });
        const deleted = await deleteConfiguracionDescuento(key);
        if (deleted) {
          setVisibleAlert(false);
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    form.setFieldsValue(record);
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const onClickAdd = () => {
    setEstadosFiltered(estados);
    onCancel();
    setCurrentTabKey('generales');
    setDisabledCampoAcreedores(true);
    setDisabledCampoFechaDevolucion(true);
    setVisible(true);
  };

  const onClickDelete = () => {
    setVisibleAlert(true);
  };

  const showMsg = makeMessager(setCurrentTabKey);

  const onChangeTabKey = makeOnChangeTabKey(
    basicKeys,
    complexForms,
    currentTabKey,
    setCurrentTabKey,
    showMsg,
  );

  const onChangeTipoDescuento = (value) => {
    // eslint-disable-next-line default-case
    switch (value) {
      case DESCUENTO_RECURRENTE_Y_VARIABLE:
        setTipoDescuento(value);
        form.setFieldsValue({
          aplica_importe_fijo: false,
          aplica_importe_variable: true,
          aplica_porcentaje_predeterminado_importe_variable: false,
          porcentaje_predeterminado_importe_variable: undefined,
          aplica_importe_de_calculo_externo: false,
          aplica_importe_base: false,
          aplica_periodo_unico_de_descuento: false,
          aplica_no_periodos_determinados: false,
          aplica_determinacion_de_importe_fijo_de_descuento: false,
          aplica_no_de_descuento_con_que_inicia: false,
          aplica_contador_de_descuentos: false,
          es_recurrente: true,
          aplica_cuenta_contable_del_empleado: false,
          aplica_control_de_saldos: false,
          aparece_en_recibo_el_saldo: false,
          aplica_acumulado: true,
          aparece_en_recibo_el_acumulado: true,
          requiere_datos_informativos: false,
          requiere_beneficiarios_externos: false,
          aplica_suspencion: true,
        });
        form.resetFields(['porcentaje_predeterminado_importe_variable']);
        break;
      case DESCUENTO_TEMPORAL:
        setTipoDescuento(value);
        form.setFieldsValue({
          aplica_importe_fijo: true,
          aplica_importe_variable: false,
          aplica_porcentaje_predeterminado_importe_variable: false,
          porcentaje_predeterminado_importe_variable: undefined,
          aplica_importe_de_calculo_externo: false,
          aplica_importe_base: true,
          aplica_periodo_unico_de_descuento: false,
          aplica_no_periodos_determinados: true,
          aplica_determinacion_de_importe_fijo_de_descuento: true,
          aplica_no_de_descuento_con_que_inicia: true,
          aplica_contador_de_descuentos: true,
          es_recurrente: false,
          aplica_cuenta_contable_del_empleado: true,
          aplica_control_de_saldos: true,
          aparece_en_recibo_el_saldo: true,
          aplica_acumulado: false,
          aparece_en_recibo_el_acumulado: false,
          requiere_datos_informativos: false,
          requiere_beneficiarios_externos: false,
          aplica_suspencion: true,
        });
        form.resetFields(['porcentaje_predeterminado_importe_variable']);
        break;
      case DESCUENTO_UNICOS:
        setTipoDescuento(value);
        form.setFieldsValue({
          aplica_importe_fijo: true,
          aplica_importe_variable: false,
          aplica_porcentaje_predeterminado_importe_variable: false,
          porcentaje_predeterminado_importe_variable: undefined,
          aplica_importe_de_calculo_externo: false,
          aplica_importe_base: false,
          aplica_periodo_unico_de_descuento: true,
          aplica_no_periodos_determinados: false,
          aplica_determinacion_de_importe_fijo_de_descuento: false,
          aplica_no_de_descuento_con_que_inicia: false,
          aplica_contador_de_descuentos: false,
          es_recurrente: false,
          aplica_cuenta_contable_del_empleado: false,
          aplica_control_de_saldos: false,
          aparece_en_recibo_el_saldo: false,
          aplica_acumulado: true,
          aparece_en_recibo_el_acumulado: true,
          requiere_datos_informativos: false,
          requiere_beneficiarios_externos: false,
          aplica_suspencion: true,
        });
        form.resetFields(['porcentaje_predeterminado_importe_variable']);
        break;
      case DESCUENTO_RECURRENTE_Y_FIJO:
        setTipoDescuento(value);
        form.setFieldsValue({
          aplica_importe_fijo: true,
          aplica_importe_variable: false,
          aplica_porcentaje_predeterminado_importe_variable: false,
          porcentaje_predeterminado_importe_variable: undefined,
          aplica_importe_de_calculo_externo: false,
          aplica_importe_base: false,
          aplica_periodo_unico_de_descuento: false,
          aplica_no_periodos_determinados: false,
          aplica_determinacion_de_importe_fijo_de_descuento: false,
          aplica_no_de_descuento_con_que_inicia: false,
          aplica_contador_de_descuentos: false,
          es_recurrente: true,
          aplica_cuenta_contable_del_empleado: false,
          aplica_control_de_saldos: false,
          aparece_en_recibo_el_saldo: false,
          aplica_acumulado: true,
          aparece_en_recibo_el_acumulado: true,
          requiere_datos_informativos: false,
          requiere_beneficiarios_externos: false,
          aplica_suspencion: true,
        });
        form.resetFields(['porcentaje_predeterminado_importe_variable']);
        break;
      case DESCUENTO_DE_CALCULO_EXTERNO:
        setTipoDescuento(value);
        form.setFieldsValue({
          aplica_importe_fijo: false,
          aplica_importe_variable: false,
          aplica_porcentaje_predeterminado_importe_variable: false,
          porcentaje_predeterminado_importe_variable: undefined,
          aplica_importe_de_calculo_externo: true,
          aplica_importe_base: false,
          aplica_periodo_unico_de_descuento: false,
          aplica_no_periodos_determinados: false,
          aplica_determinacion_de_importe_fijo_de_descuento: false,
          aplica_no_de_descuento_con_que_inicia: false,
          aplica_contador_de_descuentos: false,
          es_recurrente: false,
          aplica_cuenta_contable_del_empleado: false,
          aplica_control_de_saldos: false,
          aparece_en_recibo_el_saldo: false,
          aplica_acumulado: true,
          aparece_en_recibo_el_acumulado: true,
          requiere_datos_informativos: false,
          requiere_beneficiarios_externos: false,
          aplica_suspencion: true,
        });
        form.resetFields(['porcentaje_predeterminado_importe_variable']);
        break;
    }
  };

  const onChangeAplicaFormatoDeConsulta = (value) => {
    setAplicaFormatoDeConsulta(value);
    form.resetFields(['formato_de_consulta']);
  };

  const columns = [
    {
      titleText: 'Clave',
      dataIndex: 'clave',
      key: 'clave',
      width: 200,
    },
    {
      titleText: 'Clave Anterior',
      dataIndex: 'clave_anterior',
      key: 'clave_anterior',
      width: 200,
    },
    {
      titleText: 'Concepto',
      dataIndex: 'concepto',
      key: 'concepto',
      width: 300,
    },
    {
      titleText: 'Prioridad',
      dataIndex: 'prioridad_del_descuento',
      key: 'prioridad_del_descuento',
      width: 200,
    },
    {
      titleText: 'Tipo de Descuento',
      dataIndex: 'tipo_de_descuento',
      key: 'tipo_de_descuento',
      width: 250,
      render: (val) => tiposDescuentos.find((e) => e.id === val)?.nombre,
    },
    {
      titleText: 'Acreedor',
      dataIndex: 'acreedor',
      key: 'acreedor',
      width: 200,
      render: (val) => acreedores.find((e) => e.id === val)?.nombre_comercial,
    },
    {
      titleText: 'Cuenta Contable',
      dataIndex: 'cuenta_contable',
      key: 'cuenta_contable',
      width: 700,
      render: (val) => {
        const _cuenta = cuentas.find((e) => e.id === val);
        if (_cuenta) {
          return `${_cuenta?.clave_visible || _cuenta?.clave} - ${_cuenta?.nombre}`;
        }
        return '';
      },
    },
    {
      titleText: 'Admite Más de Uno',
      dataIndex: 'admite_mas_de_un_descuento_simultaneo',
      key: 'admite_mas_de_un_descuento_simultaneo',
      width: 200,
      render: (val) => (val ? 'Si' : 'No'),
    },
    {
      titleText: 'Importe Fijo',
      dataIndex: 'aplica_importe_fijo',
      key: 'aplica_importe_fijo',
      width: 200,
      render: (val) => (val ? 'Si' : 'No'),
    },
    {
      titleText: 'Importe Variable',
      dataIndex: 'aplica_importe_variable',
      key: 'aplica_importe_variable',
      width: 200,
      render: (val) => (val ? 'Si' : 'No'),
    },
    {
      titleText: 'Aplica Cálculo Externo',
      dataIndex: 'aplica_importe_de_calculo_externo',
      key: 'aplica_importe_de_calculo_externo',
      width: 200,
      render: (val) => (val ? 'Si' : 'No'),
    },
    {
      titleText: 'Aplica Periodo Único de Descuento',
      dataIndex: 'aplica_periodo_unico_de_descuento',
      key: 'aplica_periodo_unico_de_descuento',
      width: 270,
      render: (val) => (val ? 'Si' : 'No'),
    },
    {
      titleText: 'Aplica No. de Periodos Determinados',
      dataIndex: 'aplica_no_periodos_determinados',
      key: 'aplica_no_periodos_determinados',
      width: 280,
      render: (val) => (val ? 'Si' : 'No'),
    },
    {
      titleText: 'Aplica Determinación de Importe de Descuento',
      dataIndex: 'aplica_determinacion_de_importe_fijo_de_descuento',
      key: 'aplica_determinacion_de_importe_fijo_de_descuento',
      width: 340,
      render: (val) => (val ? 'Si' : 'No'),
    },
    {
      titleText: 'Aplica Periodo de Inicio de Descuento',
      dataIndex: 'aplica_no_de_descuento_con_que_inicia',
      key: 'aplica_no_de_descuento_con_que_inicia',
      width: 290,
      render: (val) => (val ? 'Si' : 'No'),
    },
    {
      titleText: 'Aplica Contador de Descuentos',
      dataIndex: 'aplica_contador_de_descuentos',
      key: 'aplica_contador_de_descuentos',
      width: 250,
      render: (val) => (val ? 'Si' : 'No'),
    },
    {
      titleText: 'Es Recurrente',
      dataIndex: 'es_recurrente',
      key: 'es_recurrente',
      width: 200,
      render: (val) => (val ? 'Si' : 'No'),
    },
    {
      titleText: 'Aplica Cuenta Contable del Empleado',
      dataIndex: 'aplica_cuenta_contable_del_empleado',
      key: 'aplica_cuenta_contable_del_empleado',
      width: 280,
      render: (val) => (val ? 'Si' : 'No'),
    },
    {
      titleText: 'Aplica Control de Saldo',
      dataIndex: 'aplica_control_de_saldos',
      key: 'aplica_control_de_saldos',
      width: 200,
      render: (val) => (val ? 'Si' : 'No'),
    },
    {
      titleText: 'Aparece en Recibo',
      dataIndex: 'aparece_en_recibo_el_saldo',
      key: 'aparece_en_recibo_el_saldo',
      width: 200,
      render: (val) => (val ? 'Si' : 'No'),
    },
    {
      titleText: 'Aplica Acumulado',
      dataIndex: 'aplica_acumulado',
      key: 'aplica_acumulado',
      width: 200,
      render: (val) => (val ? 'Si' : 'No'),
    },
    {
      titleText: 'Requiere Datos Informativos',
      dataIndex: 'requiere_datos_informativos',
      key: 'requiere_datos_informativos',
      width: 230,
      render: (val) => (val ? 'Si' : 'No'),
    },
    {
      titleText: 'Aplica Beneficiarios Externos',
      dataIndex: 'requiere_beneficiarios_externos',
      key: 'requiere_beneficiarios_externos',
      width: 240,
      render: (val) => (val ? 'Si' : 'No'),
    },
    {
      titleText: 'Aplica Suspensión',
      dataIndex: 'aplica_suspencion',
      key: 'aplica_suspencion',
      width: 200,
      render: (val) => (val ? 'Si' : 'No'),
    },
    {
      titleText: 'Observaciones',
      dataIndex: 'observaciones',
      key: 'observaciones',
      width: 500,
    },
    {
      titleText: 'Estatus',
      dataIndex: 'estados_globales',
      key: 'estados_globales',
      width: 200,
      render: (val) => estados.find((e) => e.id === val)?.descripcion,
    },
  ];

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const rules = {
    required: [requiredRule],
    contratacion: [requiredRule],
    estatus: [requiredRule],
    clave: [
      requiredRule,
      {
        pattern: SLUG_PATTERN,
        message: 'Ingrese una clave válida',
      },
    ],
    entero: [
      requiredRule,
      {
        pattern: integerRegExp,
        message: 'Ingrese un valor válido',
      },
    ],
    valor: [
      requiredRule,
      {
        pattern: FLOAT_NUMER_PATTERN,
        message: 'Ingrese un valor válido',
      },
    ],
  };

  const handleOnFinishConfirmation = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      if (!key) {
        setLoading(false);
        onCancel();
        onSuccess({}, 'No se puede autorizar una nómina ya autorizada');
        return;
      }
      const vals = {
        ...form.getFieldValue(),
        estados_globales: ESTATUS_AUTORIZADO,
      };
      const res = await patchConfiguracionDescuento(key, vals);
      if (res) {
        onSuccess(res);
        const _data = await getConfiguracionDescuentos();
        setData(formatReceived(_data));
        setConfirmationVisible(false);
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnFinishCancelar = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      if (!key) {
        setLoading(false);
        onCancel();
        return;
      }
      const res = await patchConfiguracionDescuento(key, { estados_globales: ESTATUS_CANCELADO });
      if (res) {
        onSuccess(res);
        const _data = await getConfiguracionDescuentos();
        setData(formatReceived(_data));
        setConfirmationCancelarVisible(false);
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnFinishReactivar = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      if (!key) {
        setLoading(false);
        onCancel();
        return;
      }
      const res = await patchConfiguracionDescuento(key, { estados_globales: ESTATUS_ACTIVO });
      if (res) {
        onSuccess(res);
        const _data = await getConfiguracionDescuentos();
        setData(formatReceived(_data));
        setConfirmationReactivarVisible(false);
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        {!open ? (
          <Table
            cols={columns}
            data={data}
            titleTable="Descuentos"
            rowSelection={rowSelection}
            handleOnRowClick={handleOnRowClick}
            controls={{
              onClickAdd,
              onClickEdit: () => onClickEdit(),
              onClickDelete,
            }}
            disableDelete={
              data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_AUTORIZADO
            }
            customActions={[
              {
                onClick: () => setConfirmationVisible(true),
                permission: { model: 'descuento', action: 'autorizar' },
                text: 'Autorizar',
                icon: <CheckCircleOutlined />,
                disabledBySelection: false,
                className: 'success',
                disabled: !selectedRowKeys?.length
                  || data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_AUTORIZADO
                  || data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_CANCELADO
                  || data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_INACTIVO,
              },
              {
                onClick: () => setConfirmationCancelarVisible(true),
                permission: { model: 'descuento', action: 'cancelar' },
                text: 'Cancelar',
                icon: <CloseCircleOutlined />,
                disabledBySelection: false,
                className: 'cancel',
                disabled: !selectedRowKeys?.length
                  || data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_CANCELADO,
              },
              {
                onClick: () => setConfirmationReactivarVisible(true),
                permission: { model: 'descuento', action: 'reactivar' },
                text: 'Reactivar',
                icon: <RedoOutlined />,
                disabledBySelection: false,
                className: 'success',
                disabled: !selectedRowKeys?.length
                  || data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_ACTIVO,
              },
            ]}
            allowImport
            allowExportPDF={false}
            baseURI={baseURI}
            permission={permission}
          />
        ) : (
          <Card
            className="form-container"
            title={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Descuento`}
            extra={(
              <FormSubmitControls
                onFinish={onFinish}
                onCancel={onCancel}
                loading={loading}
                onFinishText="Guardar y Continuar"
                allowSave={!disableSave}
              />
            )}
            bordered={false}
          >
            <Form
              layout="vertical"
              form={form}
              onFinish={onFinish}
              scrollToFirstError
              name="general"
            >
              <Tabs
                activeKey={currentTabKey}
                onChange={mutable ? onChangeTabKey : setCurrentTabKey}
                type="card"
              >
                <TabPane
                  tab="Generales"
                  key="generales"
                  forceRender
                >
                  <Row gutter={10}>
                    <Col xs={24} sm={24} md={24}>
                      <DescuentoGenerales
                        form={form}
                        estados={estadosFiltered}
                        estatusInactivo={estatusInactivo}
                        estatusAutorizado={estatusAutorizado}
                        setConfirmationVisibleEstatus={setConfirmationVisibleEstatus}
                        selectedRowKeys={selectedRowKeys}
                        acreedores={acreedores}
                        cuentas={cuentas}
                        tiposDescuentos={tiposDescuentos}
                        tiposDeducciones={tiposNominas}
                        destinosDelDescuento={destinosDelDescuento}
                        fechasDevolucionesEmpleados={fechasDevolucionesEmpleados}
                        disabledCampoAcreedores={disabledCampoAcreedores}
                        disabledCampoFechaDevolucion={disabledCampoFechaDevolucion}
                        aplicaFormatoDeConsulta={aplicaFormatoDeConsulta}
                        formatosDeConsultas={formatosDeConsultas}
                        onChangeAplicaFormatoDeConsulta={onChangeAplicaFormatoDeConsulta}
                        infoTooltipTipoDescuento={infoTooltipTipoDescuento}
                        getInfoTipoDescuento={getInfoTipoDescuento}
                        onChangeTipoDescuento={onChangeTipoDescuento}
                        onChangeAcreedor={handleChangeAcreedor}
                        rules={rules}
                        setDisableAplicanRangoSalariales={setDisableAplicanRangoSalariales}
                        setDisableRequiereDatosInformativos={setDisableRequiereDatosInformativos}
                      />
                    </Col>
                    {selectedRowKeys.length
                      ? (
                        <>
                          <p style={{ color: '#D88F4F', fontWeight: 600, marginBottom: 0 }}>Tipo de Nómina</p>
                          <DescuentoTipoDeNomina
                            permission={getPermissionNominas}
                            selected={selectedRowKeys[0]}
                            estatusInactivo={estatusInactivo}
                            estatusAutorizado={estatusAutorizado}
                          />
                        </>
                      ) : null}
                    {selectedRowKeys.length
                      ? (
                        <>
                          <p
                            style={{ color: '#D88F4F', fontWeight: 600, marginBottom: 0 }}
                          >
                            Tipo de Nómina Empleado
                          </p>
                          <DescuentoTipoDeNominaEmpleado
                            permission={getPermissionEmpleados}
                            selected={selectedRowKeys[0]}
                            estatusInactivo={estatusInactivo}
                            estatusAutorizado={estatusAutorizado}
                          />
                        </>
                      ) : null}
                  </Row>
                </TabPane>
                <TabPane
                  tab="Parámetros"
                  key="parametros"
                  forceRender
                >
                  <DescuentoParametros
                    form={form}
                    rules={rules}
                    disableTabla={disableTabla}
                    estatusInactivo={estatusInactivo}
                    estatusAutorizado={estatusAutorizado}
                    setDisableTabla={setDisableTabla}
                    selectedRowKeys={selectedRowKeys}
                    tipoDescuento={tipoDescuento}
                    setTipoDescuento={setTipoDescuento}
                    setAplicaPorcentaje={setAplicaPorcentaje}
                    aplicaPorcentaje={aplicaPorcentaje}
                    permission={getPermissionNominas}
                    descuentoInfo={descuentoInfo}
                    disaleAplicaPorcentaje={disaleAplicaPorcentaje}
                    setDisableAplicaPorcentaje={setDisableAplicaPorcentaje}
                    disableAplicanRangosSalariales={disableAplicanRangosSalariales}
                    disableRequiereDatosInformativos={disableRequiereDatosInformativos}
                  />
                </TabPane>
              </Tabs>
              <Form.Item hidden>
                <Button htmlType="submit" />
              </Form.Item>
            </Form>
          </Card>
        )}
        <ModalDelete
          onDelete={deleteItem}
          onCancel={() => setVisibleAlert(false)}
          open={visibleAlert}
          content={`Descuento ${form.getFieldValue('clave')}`}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={handleOnFinishConfirmation}
          ConfirmAutorize
          onCancel={() => {
            setConfirmationVisible(false);
          }}
          open={confirmationVisible}
          contentTitle={`Autorizar el Descuento ${form.getFieldValue('clave')}`}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={handleOnFinishCancelar}
          ConfirmCancel
          onCancel={() => {
            setConfirmationCancelarVisible(false);
          }}
          open={confirmationCancelarVisible}
          contentTitle={`Cancelar el Descuento ${form.getFieldValue('clave')}`}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={handleOnFinishReactivar}
          onFinishText="Reactivar"
          onFinishIcon={<RedoOutlined />}
          onCancel={() => {
            setConfirmationReactivarVisible(false);
          }}
          open={confirmationReactivarVisible}
          contentTitle={`Reactivar el Descuento ${form.getFieldValue('clave')}`}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={handleOnFinishConfirmationEstatus}
          ConfirmInactive
          onCancel={() => {
            setConfirmationVisibleEstatus(false);
            form.setFieldValue('estados_globales', 1);
          }}
          open={confirmationVisibleEstatus}
          contentTitle={`Inactivar el Descuento ${form.getFieldValue('clave')}`}
          loading={loading}
        />
      </Spin>
    </Row>
  );
};

export default DescuentosConfiguraciones;
